<template>
  <table-layout title="سطل زباله" :showSearch="false">
    <template #buttons>

      <router-link v-if="contentType=='posts'" :to="{ name: 'PostsDashboard' }" class="ml-2">
        <b-button pill variant="purple"> بازگشت به صفحه لیست پست ها</b-button>
      </router-link>

      <router-link v-else-if="contentType=='pages'" :to="{ name: 'PagesDashboard' }" class="ml-2">
        <b-button pill variant="purple"> بازگشت به صفحه لیست برگه ها</b-button>
      </router-link>

      <router-link v-else-if="contentType=='lesson'" :to="{ name: 'LessonsDashboard' }" class="ml-2">
        <b-button pill variant="purple"> بازگشت به صفحه لیست درس ها</b-button>
      </router-link>

    </template>
    <template #table>
      <tabel-items :items="TrashContents" :restoreState="true"/>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </b-row>
    </template>


  </table-layout>
</template>

<script>
import TableLayout from "../TableLayout.vue";
import tabelItems from "./tableItems.vue";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {mapGetters} from "vuex";
import Pagination from "../Pagination";

export default {
  name: "trashItems",
  components: {TableLayout, tabelItems, Pagination},
  data() {
    return {
      tableAttributes,
      contentTypes: {
        posts: 'post',
        pages: 'page',
        lesson: 'lesson',
      }
    };
  },
  computed: {
    ...mapGetters({
      'TrashContents': "Content/getTrashContents",
      paginationMeta: "Content/getPaginationMeta",
    }),
    contentType() {
      return this.$router.currentRoute.params.type
    }
  },
  methods: {
    changePage(page) {
      const form = {content_type: this.contentTypes[this.contentType], page: page}
      this.$store.dispatch("Content/getTrashContents", form);
    },
  },
  mounted() {
    const form = {content_type: this.contentTypes[this.contentType], page: 1}
    this.$store.dispatch("Content/getTrashContents", form)
  }
};
</script>